import { ArrowBackIos } from '@mui/icons-material';
import { Box, Divider, LinearProgress, Stack, Typography } from '@mui/material';
import { RenderForm } from '@uplift/pages';
import { Button, ContextualNavigationLayoutProps } from '@uplift/ui-v2';
import React from 'react';
import { useHistory } from 'react-router';


export type AssessmentsAdministrationProps = {
  sessionId: string;
  patientId: string;
};


const FormLayout: React.VFC<ContextualNavigationLayoutProps> = (props) => {
  const history = useHistory();

  return (
    <Box>
      {typeof props.progress === 'number' ? <LinearProgress variant="determinate" value={props.progress} /> : props.progress}
      <Box sx={{ p: 2 }}>
        <Stack alignItems="flex-start">
          <Typography variant="body2">Recorded as clinician-administered.</Typography>
          <Button sx={{ ml: -1 }} onClick={() => history.push('/')} startIcon={<ArrowBackIos sx={{ fontSize: '10px !important' }} />} variant="text" size="small">Back to assessments</Button>
        </Stack>
        <Divider />
        {props.children}
      </Box>
    </Box>
  );
};


export const AssessmentForm = () => {
  return (
    <Box>
      <RenderForm
        LayoutComponent={FormLayout}
      />
    </Box>
  );
};
